<template>
  <ProToPlusReactivationCard
    :isPriceLoading="isPriceLoading"
    :plusMonthlyPrice="plusMonthlyPrice"
    :annualPrice="annualPrice"
    :proPrice="proPrice"
    :isPricingComparison="isPricingComparison"
    :monthlySavings="monthlySavings"
    @reactivate="$emit('reactivate')"
  />
</template>

<script setup>
import ProToPlusReactivationCard from '@/components/homePage/studioPlus/ProToPlusReactivationCard.vue'

defineProps({
  isPriceLoading: {
    type: Boolean,
    default: false,
  },
  plusMonthlyPrice: {
    type: Number,
    default: 0,
  },
  annualPrice: {
    type: Number,
    default: 0,
  },
  proPrice: {
    type: Number,
    default: 0,
  },
  isPricingComparison: {
    type: Boolean,
    default: false,
  },
  monthlySavings: {
    type: Number,
    default: 0,
  },
})

defineEmits(['reactivate'])
</script>
